'use client';

import AIInterviewFlow from '@components/templates/ai-interview/AiInterviewFlow';

interface JobBasedAiInterviewProps {
  jobSlug: string;
  locale: Locale;
  questions: ApiSchema<'InterviewUserQuestionRead'>[] | null;
  onComplete?: () => void;
}

const JobAiInterview = (props: JobBasedAiInterviewProps) => {
  const {
    jobSlug, locale, questions, onComplete,
  } = props;

  return (
    <AIInterviewFlow
      key={`job-interview-${jobSlug}`}
      autostart
      questionsFromApi={questions}
      locale={locale}
      fileNamePrefix="jVideo"
      firebaseFolder="job_interview_video"
      timersConfiguration={{
        readCountdown: 20,
        recordingDuration: 60,
        timeBeforeManualStartEnabled: 5,
        timeBeforeManualNextEnabled: 10,
      }}
      onComplete={onComplete}
    />
  );
};

export default JobAiInterview;
